import { Directive, OnInit, HostListener, ElementRef, Renderer2, Input, Output, EventEmitter, OnDestroy, OnChanges, SimpleChanges } from '@angular/core';
import { Subject, Subscription } from 'rxjs';
import { debounceTime } from 'rxjs/operators';

@Directive({
  selector: '[appDebounceClick]'
})
export class DebounceClickDirective implements OnInit, OnDestroy, OnChanges {
  @Input() debounceTime: number = 500;
  @Input() formSubmissions: number;

  @Output() debounceClick = new EventEmitter();

  private clicks = new Subject();
  private subscription: Subscription;

  constructor(private renderer: Renderer2, private hostElement: ElementRef) { }

  ngOnInit() {
    this.subscription = this.clicks.pipe(
      debounceTime(this.debounceTime)
    ).subscribe(e => this.debounceClick.emit(e));
   }

   ngOnDestroy() {
     this.subscription.unsubscribe();
   }

   ngOnChanges(changes: SimpleChanges) {
     if (changes && changes.formSubmissions && changes.formSubmissions.currentValue) {
       this.hostElement.nativeElement.removeAttribute('disabled');
       this.renderer.removeClass(this.hostElement.nativeElement, 'btn-run-progress');
     }
   }

  @HostListener('click', ['$event'])
  clickEvent(event) {
    event.preventDefault();
    event.stopPropagation();

    let target = event.target || event.srcElement;
    target.setAttribute('disabled', true);
    this.renderer.addClass(this.hostElement.nativeElement, 'btn-run-progress');

    this.clicks.next(event);
  }
}
